// 구매후기 목록 섹션 URL (2026-08-25 KST 추가)
const reviewsSection = "/reviews";

export const reviewsPath = reviewsSection;
